import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';

const TermsPage = () => {
  // Set page meta tags
  usePageMeta({
    title: 'Terms of Service | BM-Assist.co',
    description: 'Read the terms and conditions for using BM-Assist.co services. Learn about our service policies, user responsibilities, and legal agreements.',
    ogTitle: 'Terms of Service | BM-Assist.co',
    ogDescription: 'Terms and conditions governing the use of BM-Assist.co marketing services.'
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold" style={{ color: '#1E3A8A' }}>
            BM-Assist.co
          </Link>
          <Link
            to="/"
            className="text-gray-600 hover:text-blue-900 font-medium flex items-center gap-2"
          >
            ← Back to site
          </Link>
        </div>
      </nav>

      {/* Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#1E3A8A' }}>
            Terms of Service
          </h1>
          <p className="text-gray-500 mb-8">Last updated: November 2025</p>

          <div className="prose prose-lg max-w-none">
            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Overview
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              By accessing or using BM-Assist.co, you agree to be bound by these Terms of Service. If you disagree, please do not use our website.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Use of Services
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Our website provides information and allows users to request marketing or administrative services. You agree not to misuse our services or access them using automated means.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Intellectual Property
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              All content on this site, including text, graphics, and logos, is owned by BM-Assist.co or licensed to us. You may not copy or reuse materials without written permission.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Liability
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              We make reasonable efforts to maintain accurate and reliable information but do not guarantee it. BM-Assist.co shall not be held liable for any direct or indirect damages from using our site or services.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Service Changes
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              We may modify, suspend, or discontinue any part of the website without notice.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Governing Law
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              These terms are governed by the laws of the United States and the State of North Carolina.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-gray-600">
            © 2025 BM-Assist.co | All rights reserved |{' '}
            <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link> |{' '}
            <Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link> |{' '}
            <Link to="/cookies" className="text-blue-600 hover:underline">Cookie Policy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
